export class ListGdsgInventoryReportConfigurationsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "configurations",
            "baseName": "configurations",
            "type": "Array<GdsgInventoryReportConfiguration>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGdsgInventoryReportConfigurationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
